export const brands = ["apple", "huawei", "samsung"];
